<template>
  <sections-extra-layout>
    <template slot="title">Last step</template>
    <template slot="description">Define the last step button</template>
    <template slot="content">
      <div>
        <p class="font-bold mb-4">What is the text of the last step button ?</p>
        <div class="mt-2">
          <label v-for="lang in (languages)" :key="lang" class=" cursor-pointer w-full mb-2 inline-flex items-center ml-6">
            <span class="ml-2 w-1/12 inline-block">{{ lang }}</span>
            <input v-model="text[lang]" type="text" @change="emitText()" placeholder="last button text" class="w-11/12 mx-4 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline">
          </label>
        </div>
        <p class="font-bold mb-4">Action of the button</p>
        <p v-if="lock" class="-mt-4 mb-4">
          <span class="material-symbols-outlined align-middle text-base">
            info
          </span>
          The URL of the last step is locked because it is already filled in the imported csv
        </p>
        <div class="mt-2"  id="input-action-container">
          <label class="cursor-pointer w-full mb-4 inline-flex items-center ml-6" :class="{'cursor-not-allowed': lock}">
            <input v-model="withUrl" @change="setWithLink()" type="radio" class="form-radio" v-bind:value="false" :disabled="lock">
            <span class="ml-2">Close the wave</span>
          </label>
          <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6" :class="{'cursor-not-allowed': lock}">
            <input v-model="withUrl" @change="setWithLink()" type="radio" class="form-radio" v-bind:value="true" :disabled="lock">
            <span class="ml-2">Redirect to an URL</span>
            <input v-model="url" type="text" placeholder="url" @change="checkInput()" :disabled="lock" :class="{'text-gray-500': lock, 'text-gray-700': !lock, 'cursor-not-allowed': lock}" class="w-11/12 mx-4 px-3 py-3 placeholder-gray-400 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline">
          </label>
          <p class="ml-6 mb-2 error" v-if="withUrl && !url">url is empty</p>
          <label v-if="withUrl" class="cursor-pointer mb-4 inline-flex items-center ml-6">
            <input v-model="openinnewtab" @change="emitOpenInNewTab()" type="checkbox" class="form-checkbox">
            <span class="ml-2">Open in new tab</span>
          </label>
        </div>
      </div>
    </template>
  </sections-extra-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LastStep',
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      text: {
        fr: "J'ai compris",
        en: "Understood",
        ch: "明白了"
      },
      withUrl: false,
      url: null,
      targetObject: {},
      lock: false,
      openinnewtab: false
    }
  },
  computed: {
    ...mapGetters('account', {
      defaultLang: 'defaultLang',
      site: 'currentSite'
    }),
    languages () {
      return this.site.languages.map(lang => lang.lang)
    }
  },
  methods: {
    emitLink () {
      this.$emit('update-lastStepUrl', this.url)
    },
    emitText () {
      let newText = this.text
      if (this.languages.includes("fr") && newText.fr === "") {
        newText.fr = "J'ai compris"
      }
      if (this.languages.includes("en") && newText.en === "") {
        newText.en = "Understood"
      }
      this.$emit('update-lastStepText', newText)
    },
    emitOpenInNewTab () {
      this.$emit('update-openinnewtab', this.openinnewtab)
    },
    checkInput () {
      this.withUrl = (this.url != null || thisLink != '')
      this.emitLink()
    },
    setWithLink () {
      if(!this.withUrl) {
        this.url = null
      }
      this.emitLink()
    }
  },
  mounted () {
    if (this.data) {this.targetObject = this.data}
    if (this.targetObject) {
      if (this.targetObject.csvFields.includes("last_step_url")) {
        this.url = "[[last_step_url]]"
        this.withUrl = true
        this.lock = true
      } else if (this.targetObject.lastStepUrl) {
        this.url = this.targetObject.lastStepUrl
        this.withUrl = this.targetObject.lastStepUrl !== null && this.targetObject.lastStepUrl !== ''
      }
      if (this.targetObject.lastStepText) {
        this.text = this.targetObject.lastStepText
      }
      if (this.targetObject.openinnewtab) {
        this.openinnewtab = this.targetObject.openinnewtab
      }
    }
  }
}

</script>

<style scoped>
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/waves/ui/form/last-step.vue